import React from 'react'
import * as Styled from './Slider.styles'

const Slider = ({ slides }) => {
  const slideWidth = 80
  const sliderRef = React.useRef(null)
  const sliderContentRef = React.useRef(null)

  const [activeIndex, setActiveIndex] = React.useState(0)

  const scrollTo = (element, to, duration) => {
    const start = element.scrollLeft
    const change = to - start
    let currentTime = 0
    const increment = 20

    /**
     * Ease in out animation
     * @param {Number} t current time
     * @param {Number} b start value
     * @param {Number} c change in value
     * @param {Number} d duration
     */
    const easeInOutQuad = (t, b, c, d) => {
      t /= d / 2
      if (t < 1) return (c / 2) * t * (t + b)
      t -= 1
      return (-c / 2) * (t * (t - 2 - 1 + b))
    }

    const animateScroll = () => {
      currentTime += increment
      const val = easeInOutQuad(currentTime, start, change, duration)

      element.scrollLeft = val
      if (currentTime < duration) {
        setTimeout(animateScroll, increment)
      }
    }

    animateScroll()
  }

  const nextSlide = () => {
    if (sliderContentRef && sliderContentRef.current) {
      const contentWidth = sliderContentRef.current.offsetWidth

      const nextChild = parseInt(
        (sliderContentRef.current.scrollLeft + contentWidth) /
          (slideWidth + 15),
        10
      )
      if (nextChild < sliderContentRef.current.children.length) {
        scrollTo(
          sliderContentRef.current,
          sliderContentRef.current.children[nextChild].offsetLeft - 60,
          600
        )
      }
    }
  }

  const prevSlide = () => {
    if (sliderContentRef && sliderContentRef.current) {
      const contentWidth = sliderContentRef.current.offsetWidth
      scrollTo(
        sliderContentRef.current,
        (sliderContentRef.current.scrollLeft -
          parseInt(contentWidth / (slideWidth + 15), 10)) *
          95 -
          85,
        600
      )
    }
  }

  return (
    <>
      {slides && (
        <>
          <Styled.ActiveItem content={ slides[activeIndex] } />
          <Styled.Slider ref={ sliderRef }>
            <Styled.ItemList>
              <Styled.Arrow onClick={ prevSlide }>
                <Styled.ArrowIcon className='icon-f-arrow-left' />
              </Styled.Arrow>

              <Styled.SliderContent ref={ sliderContentRef }>
                {slides.map((slide, i) => (
                  <Styled.Item
                    key={ slide + i }
                    content={ slide }
                    onClick={ () => setActiveIndex(i) }
                  />
                ))}
              </Styled.SliderContent>

              <Styled.Arrow onClick={ nextSlide }>
                <Styled.ArrowIcon className='icon-f-arrow-right' />
              </Styled.Arrow>
            </Styled.ItemList>
          </Styled.Slider>
        </>
      )}
    </>
  )
}

export default Slider
